var map = {
	"./Character Sheet.html": "79e2",
	"./Characters/Alaba Caduca.html": "a8b4",
	"./Characters/Esmerlda Caduca.html": "30dd",
	"./Characters/Helen.html": "7016",
	"./Characters/John Daulx.html": "ac39",
	"./Characters/Joseph Nix.html": "f414",
	"./Characters/Mifune.html": "8430",
	"./Characters/Patton.html": "85c9",
	"./Characters/Robert Lund.html": "f1d3",
	"./Characters/Salazar.html": "8238",
	"./Characters/Tran.html": "d74d",
	"./Characters/[naa].html": "2415",
	"./Design Notes.html": "e766",
	"./README.html": "eb16",
	"./SUMMARY.html": "96b6",
	"./Setting/Avatars.html": "116f",
	"./Setting/Focus.html": "d595",
	"./Setting/Magick.html": "91c7",
	"./Setting/Welcome to Reality.html": "1c00",
	"./Stories/01 Start of Things.html": "ec7e",
	"./Stories/01.2 enter my world.html": "4266",
	"./Stories/01.3 using spirit magick.html": "8d76",
	"./Stories/01.4 third eye opens.html": "5eb0",
	"./Stories/01.5 Lets Talk.html": "ae36",
	"./Stories/02 With Great Power.html": "1a09",
	"./Stories/02.2 Participation.html": "ca6e",
	"./Stories/02.3.html": "fe04",
	"./System/Exegesis.html": "75a8",
	"./System/Making a Mage.html": "eac6",
	"./System/Mundane Actions.html": "c83d",
	"./System/Working Magick.html": "d719",
	"./debug.html": "5997",
	"./syntax tests.html": "a24e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d9d";